import {
  Box,
  Button,
  IconButton,
  Grid,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
  DialogContentText,
  CircularProgress,
  Backdrop
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import CustomSnackBar from "../CustomComponents/CustomSnackBar";
import { Delete } from "@mui/icons-material";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import CustomTextField from "../CustomComponents/CustomTextField";
import GetBranchDetails from "../CustomComponents/GetBranchDetailsWithCode";
import StlapFooter from "../CustomComponents/StlapFooter";
import { useDispatch, useSelector } from "react-redux";
import CustomDateField from "../CustomComponents/CustomDateField";
import { JournalVoucherReducerAction } from "../Store/JournalVoucherReducer";
import axios from "axios";
import CustomConfirmationDialog from "../CustomComponents/CustomConfirmationDialog";
import { BranchAction } from "../Store/Branch";
import CustomButton from "../CustomComponents/CustomButton";
import dayjs from "dayjs";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";

const JournalVoucherDetail = () => {
  const dispatch = useDispatch();
  const [savedDialogOpen, setSaveDialogOpen] = useState(false);
  const [branchNames, setBranchNames] = useState([]);
  const [branchNamesList, setBranchNamesList] = useState([]);
  const [voucherNumberList, setVoucherNumberList] = useState([]);
  const [voucherDateList, setVoucherDateList] = useState([]);
  const [voucherNumber, setVoucherNumber] = useState("");
  const [voucherNumberError, setVoucherNumberError] = useState(false);
  const [jounalNumberDialogOpen, setJounalNumberDialogOpen] = useState(false);

  const [refenceDocumentType, setRefenceDocumentType] = useState("");
  const [referenceDocumentNumber, setReferenceDocumentNumber] = useState("");
  const [referenceDocumentDate, setReferenceDocumentDate] = useState("");
  const [datarows, setDatarows] = useState([
    {
      id: 0,
      fileBranch: "",
      appNum: "",
      glAccount: "",
      description: "",
      debit: 0,
      credit: 0,
      fileBranchCode: "",
    },
  ]);
  const specialAccessHeaderMap = useSelector(
    (state) => state.specialAccess.specialAccessHeaderMap
  );
  const [naration, setNartation] = useState("");
  const [initialNarationValue, setInitialNarationValue] = useState("");
  // max value 1200 -> mobile.
  const [narationError, setNarationError] = useState(false);
  const [voucherDateError, setVoucherDateError] = useState(false);
  const [voucherDate, setVoucherDate] = useState("");
  const [voucherStatus, setVoucherStatus] = useState("");
  const [errorApplicationList, setErrorApplicationList] = useState([]);
  const [glAccountErrorList, setGlAccountErrorList] = useState([]);
  const [creditEmptyErrorList, setCreditEmptyErrorList] = useState([]);
  const [emptyRowList, setEmptyRowList] = useState([]);
  const [glAccountNotPresent, setGlAccountNotPresent] = useState(false);
  const [debitAmountNotValid, setDebitAmountNotValid] = useState(false);
  const [applicationList, setApplicationList] = useState([]);
  const [glDiscriptionList, setGlDiscriptionList] = useState({});
  const [voucherValidDateError, setVoucherValidDateError] = useState(false);
  const userName = useSelector((state) => state.branch.userName);
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
  const [narationFlag, setNarationFlag] = useState(true);
  const [saveButtonName, setSaveButtonName] = useState("");
  const [saveButton, setSaveButton] = useState(false);
  const [narrationDisable, setNarrationDisable] = useState(true);
  const [columnEditDisable, setColumnEditDisable] = useState(true);
  const [updateDisable, setUpdateDisable] = useState(true);
  const [narationLengthError, setNarationLengthError] = useState(false);
  const [createdDate, setCreatedDate] = useState([]);
  const [createdBy, setCreatedBy] = useState("");
  const [historyData, setHistoryData] = useState({});
  const [headerKey, setHeaderKey] = useState("");
  const [addRowSnackBarShow, setAddRowSnackBarShow] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [addButtonVisible, setAddButtonVisible] = useState(false);
  const [modeApproveValue, setModeApproveValue] = useState(false);
  const [creditColumnEnable, setCreditColumnEnable] = useState(false);
  const [debitColumnEnable, setDebitColumnEnable] = useState(false);
  const [jvApiDataLoading, setJVApiDataLoading] = useState(false);

  const approveRef = useRef(null);
  const saveRef = useRef(null);
  const clearRef = useRef(null);
  const viewRef = useRef(null);
  const modifyRef = useRef(null);
  const deleteRef = useRef(null);
  const addRowRef = useRef(null);
  const deleteRowRef = useRef(null);
  const [loanClosed, setLoanClosed] = useState(false);
  //State Which Maintain Discard Dialog Flag
  const [discardDialogFlag, setDiscardDialogFlag] = useState(false);
  const [activeField, setActiveField] = useState(null);
  const [activeFieldValue, setActiveFieldValue] = useState(null);
  //New spec changes
  const [validationSnackBar, setValidationSnackBar] = useState(false);
  const [validationSnackBarMessage, setValidationSnackBarMessage] =
    useState("");
  const [branchWithCode, setBranchWithCode] = useState([]);
  const [gllList, setGllList] = useState({});
  const [glAccountWithDesc, setGlAccountWithDesc] = useState([]);
  const [gLAccountArray, setGLAccountArray] = useState([]);

  //Dialog State
  const [informationDialog, setInformationDialog] = useState(false);
  const [informationDialogMessage, setInformationDialogMessage] = useState("");
  const userNames = useSelector((state) => state.branch.userName);

  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState(
    "Loading Data Please Wait ....."
  );

  useEffect(() => {
    window.addEventListener("keyup", onKeyPressEventHandler);
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    return () => {
      window.removeEventListener("keyup", onKeyPressEventHandler);
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
    };
  }, [jounalNumberDialogOpen, savedDialogOpen]);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "journalDetail",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    if (event.key === "Escape" || event.keyCode === 27) {
      if (jounalNumberDialogOpen) {
        onInformationOkHandler();
      }
      if (savedDialogOpen) {
        setSaveDialogOpen(false);
      }
    }
    if (event.ctrlKey) {
      let refList = {
        viewRef: viewRef,
        clearRef: clearRef.current !== null ? clearRef : null,
        approveRef: approveRef,
        modifyRef: modifyRef,
        deleteRef: deleteRef.current !== null ? deleteRef : null,
        addRowRef: addRowRef,
        deleteRowRef: deleteRowRef.current !== null ? deleteRef : null,
        saveRef: saveRef,
      };
      dispatch(
        CommonShortCutAction.getShortCutValue({
          event: event,
          refs: refList,
          screen: "journalDetail",
        })
      );
    }
  };

  useEffect(() => {
    const branchNames = GetBranchDetails();
    setBranchNames(branchNames);
    const branchList = [];
    branchNames.forEach((value) => {
      branchList.push(value.label);
    });
    setBranchNamesList(branchList);
    setTotalPageCount(
      datarows.length % 10 !== 0
        ? Number(Number((datarows.length / 10).toFixed()) + 1)
        : Number(Number((datarows.length / 10).toFixed()))
    );
    setTotalRowsCount(datarows.length);
    setPage(1);
  }, [datarows]);
  useEffect(() => {
    const branchWithCode = GetBranchDetailsWithCode();
    setJVApiDataLoading(true);
    getGlAccountBasedOnBranchCode(branchWithCode);
    setBranchWithCode(branchWithCode);
  }, []);

  const discardDialogOnOkClickHandler = () => {
    setNarationFlag(true);
    setNarationError(false);
    switch (activeField) {
      case "branch":
        onChangeForBranchEvent(activeFieldValue);
        setVoucherNumber("");
        setVoucherDate(null);
        setGridVisible(false);
        break;

      case "voucherNumber":
        setVoucherNumber(activeFieldValue);
        loadVoucherNumberStatus(activeFieldValue);
        let date = voucherDateList[activeFieldValue].split("/");
        setVoucherDate(dayjs(date[2] + "/" + date[1] + "/" + date[0]));
        activeFieldValue
          ? setVoucherNumberError(false)
          : setVoucherNumberError(true);
        setGridVisible(false);
        break;

      case "clear":
        setBranchName("");
        setVoucherDate(null);
        setVoucherStatus("");
        setVoucherNumber("");
        setDatarows([]);
        let newRow = {
          id: 0,
          fileBranch: "",
          appNum: "",
          glAccount: "",
          description: "",
          debit: 0,
          credit: 0,
          fileBranchCode: "",
        };
        setDatarows(newRow);
        setVoucherDateError(false);
        setVoucherNumberError(false);
        setVoucherNumberList([]);
        setBranchNameNotValid(false);
        setNartation("");
        setUpdateDisable(true);
        setModeValue("");
        setGridVisible(false);
        break;

      case "approve":
        setVoucherDateError(false);
        setVoucherNumberError(false);
        setBranchNameNotValid(false);
        setModeValue("approve");
        getVoucherDetails("approve");
        setGridVisible(true);
        setSaveButton(true);
        setSaveButtonName("Approve");
        setNarrationDisable(false);
        setColumnEditDisable(true);
        break;

      case "delete":
        setVoucherDateError(false);
        setVoucherNumberError(false);
        setBranchNameNotValid(false);
        setModeValue("delete");
        getVoucherDetails("delete");
        setGridVisible(true);
        setSaveButton(true);
        setSaveButtonName("Delete");
        setNarrationDisable(false);
        setColumnEditDisable(true);
        break;

      case "modify":
        setModeValue("modify");
        setVoucherDateError(false);
        setVoucherNumberError(false);
        setBranchNameNotValid(false);
        setGridVisible(true);
        setColumnEditDisable(false);
        setNarrationDisable(false);
        setSaveButtonName("Save");
        setSaveButtonDisabled(true);
        setSaveButton(true);
        getVoucherDetails("modify");
        break;

      case "view":
        setModeValue("view");
        setSaveButton(false);
        setVoucherDateError(false);
        setBranchNameNotValid(false);
        setVoucherNumberError(false);
        getVoucherDetails("view");
        setGridVisible(true);
        setNarrationDisable(false);
        setColumnEditDisable(true);
        break;
    }
    setSaveButtonDisabled(true);
    setDiscardDialogFlag(false);
  };
  const loadApplicationNumBasedOnBranchName = async (event) => {
    const dataMap = {};
    dataMap["branchName"] = event.row.fileBranch;
    dataMap["branchCode"] = event.row.fileBranchCode;
    dataMap["screenMode"] = "MODIFY";
    try {
      const response = await axios.post("/jv/getAppNum", dataMap);
      if (response.data) {
        setApplicationList(response.data);
      }
    } catch {
      console.log("Network Error");
    }
  };

  const loadVoucherNumber = async (newValue) => {
    const dataMap = {};
    dataMap["branchName"] = newValue.code;
    try {
      const response = await axios.post("/jv/getVoucherNumberList", dataMap);
      if (response.data) {
        setVoucherDateList(response.data.voucherDate);
        setVoucherNumberList(response.data.voucherNumberList);
      } else {
        setVoucherStatus("Processing");
      }
    } catch {
      console.log("Network Error");
    }
  };
  const loadVoucherNumberStatus = async (voucherNumber) => {
    const dataMap = {};
    dataMap["voucherNumber"] = voucherNumber;
    try {
      const response = await axios.post("/jv/loadVoucherNumberStatus", dataMap);
      if (response.data) {
        setVoucherStatus(response.data.voucherStatus);
      }
    } catch {
      console.log("Network Error");
    }
  };
  const onInformationOkHandler = () => {
    setJounalNumberDialogOpen(false);
    if (modeApproveValue === "approved") {
      setSaveButton(false);
      setVoucherDateError(false);
      setBranchNameNotValid(false);
      setVoucherNumberError(false);
      setGridVisible(true);
      setNarrationDisable(true);
      setColumnEditDisable(true);
      setAddButtonVisible(false);
    } else {
      window.location.reload();
    }
  };

  //validation disbursement status
  const validateDisbursementStatus = async() =>{

    const applNumbers = await Promise.all(
      datarows.map(async(row)=>{
        return row.appNum
      })
    )
    const applicationNumbers = [...new Set(applNumbers)]
    const params = {
      "applicationNumber":applicationNumbers
      }
    try {
      let data;
      const response = await axios.post(
        "disbursement/validateDisbursementStatus",
        params
      );
      if (response.data) {
        data = response.data
      }
      return data;
    } catch(error) {
      setValidationSnackBarMessage("Network error");
      setValidationSnackBar(true);
      throw new Error("Network error")
    }
  }

  const onSaveButtonClickHandler = async () => {
    setSaveDialogOpen(false);
    modeValue === "delete" && onDeleteButtonClickHandler();
    modeValue === "approve" && onApproveClickHandler();

    if (modeValue === "modify" && naration.length > 2000) {
      setNarationLengthError(true);
    } else {
      setNarationLengthError(false);
      modeValue === "modify" && onModifyClickHandler();
    }
  };
  const onModifyClickHandler = async () => {
    const dataMap = {};
    dataMap["mode"] = "edit";
    dataMap["user"] = userName;
    dataMap["branchName"] = branchName.code;
    dataMap["gridData"] = datarows;
    dataMap["voucherId"] = voucherNumber;
    dataMap["voucherDate"] = new Date(voucherDate).toLocaleDateString("fr-FR");
    dataMap["voucherStatus"] = voucherStatus;
    dataMap["referenceDocumentType"] = refenceDocumentType;
    dataMap["referenceDocumenNumber"] = referenceDocumentNumber;
    dataMap["referenceDocumentDate"] = referenceDocumentDate;
    dataMap["naration"] = naration;
    dataMap["historyData"] = historyData;
    dataMap["createdBy"] = createdBy;
    dataMap["createdDate"] = createdDate;
    dataMap["headerKey"] = headerKey;
    dataMap["glDescMap"] = glDiscriptionList;
    dataMap["needValidaionFlag"] = validationList.size !== 0;
    try {
      setLoading(true)
      setLoadingMsg("Saving Journal Voucher Details Please wait...")
      setSaveButtonDisabled(true);
      const response = await axios.post("/jv/saveJv", dataMap);
      if (response.data.saved) {
        setErrorDialogOpen(false);
        setJounalNumberDialogOpen(true);
        setInformationDialogContent("Journal Voucher Modified Successfully");
        setSaveButtonDisabled(false);
        setLoading(false)
      } else {
        setGlAccountDuplicateList(
          response.data.notAvailGl ? response.data.notAvailGl : []
        );
        setAccountNoIsnotReceiptedList(
          response.data.applicationNotAvail
            ? response.data.applicationNotAvail
            : []
        );
        setLoading(false)
        setSaveDialogOpen(false);
        setErrorDialogOpen(true);
      }
    } catch {
      setLoading(false)
      setSaveButtonDisabled(false);
      console.log("Network Error");
    }
  };
  const columns = [
    {
      field: "id",
      headerName: "S.No",
      headerAlign: "center",
      align: "left",
      flex: 1,
      editable: false,
      hide: true,
    },
    {
      field: "fileBranch",
      headerName: "File Branch",
      headerAlign: "center",
      align: "left",
      flex: 200,
      editable: loanClosed === true ? false : !columnEditDisable,
      type: "singleSelect",
      valueOptions: branchNamesList,
    },
    {
      field: "appNum",
      headerName: "Application Number",
      headerAlign: "center",
      align: "left",
      flex: 200,
      editable: loanClosed === true ? false : !columnEditDisable,
      type: "singleSelect",
      valueOptions: applicationList,
    },
    {
      field: "glAccount",
      headerName: "GL Account",
      headerAlign: "center",
      align: "left",
      flex: 200,
      editable: loanClosed === true ? false : !columnEditDisable,
      type: "singleSelect",
      valueOptions: gLAccountArray,
      disableColumnMenu: true,
    },
    {
      field: "description",
      headerName: "GL Description",
      headerAlign: "center",
      align: "left",
      flex: 340,
      editable: false,
    },
    {
      field: "debit",
      headerName: "Debit",
      headerAlign: "center",
      align: "right",
      flex: 160,
      type: "number",
      editable: !loanClosed && !columnEditDisable && debitColumnEnable,
      valueGetter: (value) => {
        return Number(value.value) > 0 ? Number(value.value) : "";
      },
    },
    {
      field: "credit",
      headerName: "Credit",
      headerAlign: "center",
      align: "right",
      flex: 160,
      type: "number",
      editable: !loanClosed && !columnEditDisable && creditColumnEnable,
      valueGetter: (value) => {
        return Number(value.value) > 0 ? Number(value.value) : "";
      },
    },
    {
      field: "icon",
      headerName: "",
      headerAlign: "center",
      align: "left",
      flex: 25,
      type: "number",
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      hide: columnEditDisable,
      editable: false,
      renderCell: (params) => {
        return (
          <Tooltip title="Ctrl+R" placement="right-start">
            <IconButton disabled={params.row.losStatus}>
              <Delete
                onClick={() => {
                  deleteSelectedRow(params);
                }}
                ref={deleteRowRef}
              ></Delete>
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const [page, setPage] = React.useState(1);
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);
  const [branchName, setBranchName] = useState(null);
  const [branchNameNotValid, setBranchNameNotValid] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [gridVisible, setGridVisible] = useState(false);
  const [modeValue, setModeValue] = useState("");
  const [confirmationDialogContent, setConfirmationDialogContent] =
    useState("");
  const [informationDialogContent, setInformationDialogContent] = useState("");
  const [glAccountDuplicateList, setGlAccountDuplicateList] = useState([]);
  const [accountNoIsnotReceiptedList, setAccountNoIsnotReceiptedList] =
    useState([]);
  const [accountNoIsnotReceipted, setAccountNoIsnotReceipted] = useState(false);
  const [modifiedMap, setModifiedMap] = useState({});
  const [validationList, setValidationList] = useState(new Set());

  const viewOperation = () => {
    setActiveField("view");

    if (!branchName || !voucherNumber) {
      if (!branchName) {
        branchName ? setBranchNameNotValid(false) : setBranchNameNotValid(true);
      }
      if (!voucherNumber) {
        voucherNumber
          ? setVoucherNumberError(false)
          : setVoucherNumberError(true);
      }
    } else {
      if (saveButtonDisabled && narationFlag) {
        setModeValue("view");
        setSaveButton(false);
        setVoucherDateError(false);
        setBranchNameNotValid(false);
        setVoucherNumberError(false);
        getVoucherDetails("view");
        setGridVisible(true);
        setNarrationDisable(false);
        setColumnEditDisable(true);
        setSaveButtonDisabled(true);
        setNarationError(false)
      } else {
        setDiscardDialogFlag(true);
      }
    }
  };
  const getModifiedData = (gridData) => {
    let modifiedMap = {};
    gridData.forEach(function (key) {
      modifiedMap[key["id"]] =
        key["fileBranch"] +
        key["appNum"] +
        key["glAccount"] +
        (key["debit"] ? key["debit"] : 0) +
        (key["credit"] ? key["credit"] : 0);
    });
    return modifiedMap;
  };
  const glAccountOnChangeHandler = (params) => {
    const dataIndex = datarows.findIndex((data) => {
      return data.id === params.id;
    });
    let data = datarows[dataIndex];
    const activeRowValue = datarows.find((data) => {
      return data.id === params.id;
    });
    const filterValue = datarows.map((data) => {
      return activeRowValue.appNum === data.appNum ? data : "";
    });
    let clearFlag;
    if (
      `${activeRowValue.glAccount} - ${activeRowValue.description}` ===
      params.value
    ) {
      clearFlag = false;
    } else {
      filterValue.forEach((data) => {
        const retrivalData = glAccountWithDesc.find((data) => {
          return (
            `${data["account_head"]} - ${data["account_desc"]}` === params.value
          );
        });
        if (data.glAccount === retrivalData.account_head) {
          clearFlag = true;
        }
      });
    }
    let datas;
    if (clearFlag) {
      setInformationDialog(true);
      setInformationDialogMessage(
        `This GL Account ${params.value} Is Already Used.`
      );

      datas = {
        ...data,
        glAccount: "",
        description: "",
        debit: 0,
        credit: 0,
      };
    } else {
      const retrivalData = glAccountWithDesc.find((data) => {
        return (
          `${data["account_head"]} - ${data["account_desc"]}` === params.value
        );
      });

      datas = {
        ...data,
        glAccount: retrivalData.account_head,
        description: retrivalData.account_desc,
        debit: 0,
        credit: 0,
      };
    }
    let newItem = [...datarows];
    newItem[dataIndex] = datas;
    setDatarows(newItem);
  };
  const getDebitAmountForGlAccount = async (fileBranch, appNum, glAccount) => {
    try {
      const selectedBranchCode = branchWithCode.find((branchVal) => {
        return branchVal.label === fileBranch;
      });
      const response = await axios.post("/jv/getGlAccDebitAmountFromReceipt", {
        branch: fileBranch,
        branchCode: selectedBranchCode.code,
        glAcc: glAccount,
        appNum: appNum,
        voucherNum: voucherNumber,
      });
      return response;
    } catch (e) {}
  };
  const modifyOperation = () => {
    setActiveField("modify");

    if (!branchName || !voucherNumber) {
      if (!branchName) {
        branchName ? setBranchNameNotValid(false) : setBranchNameNotValid(true);
      }
      if (!voucherNumber) {
        voucherNumber
          ? setVoucherNumberError(false)
          : setVoucherNumberError(true);
      }
    } else {
      if (saveButtonDisabled && narationFlag) {
        setModeValue("modify");
        setVoucherDateError(false);
        setVoucherNumberError(false);
        setBranchNameNotValid(false);
        setGridVisible(true);
        setColumnEditDisable(false);
        setNarrationDisable(false);
        setSaveButtonName("Save");
        setSaveButton(true);
        getVoucherDetails("modify");
        setSaveButtonDisabled(true);
        setNarationError(false)
      } else {
        setDiscardDialogFlag(true);
      }
    }
  };

  const deleteOperation = () => {
    setActiveField("delete");
    if (!branchName || !voucherNumber) {
      if (!branchName) {
        branchName ? setBranchNameNotValid(false) : setBranchNameNotValid(true);
      }
      if (!voucherNumber) {
        voucherNumber
          ? setVoucherNumberError(false)
          : setVoucherNumberError(true);
      }
    } else {
      if (saveButtonDisabled && narationFlag) {
        setVoucherDateError(false);
        setVoucherNumberError(false);
        setBranchNameNotValid(false);
        setModeValue("delete");
        getVoucherDetails("delete");
        setGridVisible(true);
        setSaveButton(true);
        setSaveButtonName("Delete");
        setNarrationDisable(false);
        setColumnEditDisable(true);
        setSaveButtonDisabled(true);
        setNarationError(false)
      } else {
        setDiscardDialogFlag(true);
      }
    }
  };
  const approveOperation = () => {
    setActiveField("approve");
    setNarationError(false)
    if (!branchName || !voucherNumber) {
      if (!branchName) {
        branchName ? setBranchNameNotValid(false) : setBranchNameNotValid(true);
      }
      if (!voucherNumber) {
        voucherNumber
          ? setVoucherNumberError(false)
          : setVoucherNumberError(true);
      }
    } else {
      if (saveButtonDisabled && narationFlag) {
        setVoucherDateError(false);
        setVoucherNumberError(false);
        setBranchNameNotValid(false);
        setModeValue("approve");
        getVoucherDetails("approve");
        setGridVisible(true);
        setSaveButton(true);
        setSaveButtonName("Approve");
        setNarrationDisable(false);
        setColumnEditDisable(true);
        setSaveButtonDisabled(true);
      } else {
        setDiscardDialogFlag(true);
      }
    }
  };

  const getVoucherDetails = async (mode) => {
    const dataMap = {};
    dataMap["branchName"] = branchName.code;
    dataMap["branchCode"] = branchName.code;
    dataMap["apiCode"] = "FILE_GL_ACC_LOV_API";
    dataMap["voucherDate"] = new Date(voucherDate).toLocaleDateString("fr-FR");
    dataMap["voucherNumber"] = voucherNumber;
    dataMap["createdBy"] = userName;
    try {
      const response = await axios.post("/jv/getVoucerData", dataMap);
      if (response.data.saved) {
        setDatarows(response.data.jounalData);
        setNartation(response.data.naration);
        setInitialNarationValue(response.data.naration);
        setVoucherStatus(response.data.voucherStatus);
        setGlDiscriptionList(response.data.glAccountMap);
        setHistoryData({});
        setCreatedBy(response.data.createdBy);
        setCreatedDate(response.data.createdDate);
        setHeaderKey(response.data.headerId);
        if (response.data.voucherStatus === "Approved" && mode !== "view") {
          setJounalNumberDialogOpen(true);
          setInformationDialogContent(
            "Journal Voucher is Already Approved.So navigating to the view Page."
          );
          setModeApproveValue("approved");
        } else {
          switch (mode) {
            case "modify":
              setSaveButtonDisabled(true);
              setNarrationDisable(false);
              setAddButtonVisible(true);
              break;
            case "approve":
              setNarrationDisable(false);
              setAddButtonVisible(false);
              break;
            case "delete":
              setNarrationDisable(false);
              setAddButtonVisible(false);
              break;
            default:
              setSaveButtonDisabled(true);
              setNarrationDisable(true);
              setAddButtonVisible(false);
              break;
          }
        }
      } else {
        setDatarows([]);
        setNartation("");
        setVoucherStatus("Processing");
      }
      setModifiedMap(getModifiedData(response.data.jounalData));
    } catch {
      console.log("Network Error");
    }
  };

  const clearButtonClickHandler = () => {
    setActiveField("clear");

    if (saveButtonDisabled && narationFlag) {
      setBranchName("");
      setVoucherDate(null);
      setVoucherStatus("");
      setVoucherNumber("");
      setDatarows([]);
      let newRow = {
        id: 0,
        fileBranch: "",
        appNum: "",
        glAccount: "",
        debit: "",
        credit: "",
      };
      setDatarows(newRow);
      setVoucherDateError(false);
      setVoucherNumberError(false);
      setVoucherNumberList([]);
      setBranchNameNotValid(false);
      setNartation("");
      setNarationError(false)
      setUpdateDisable(true);
      setModeValue("");
      setGridVisible(false);
      setSaveButtonDisabled(true);
    } else {
      setDiscardDialogFlag(true);
    }
  };
  const onRowClickHandler = (params) => {
    getGlAccountsBasedOnBranch(params.fileBranch);
  };
  const getGlAccountsBasedOnBranch = (branch) => {
    if (branch === "" || branch === null) {
      setGlAccountWithDesc([]);
      setGLAccountArray([]);
    } else {
      const selectedBranch = branchWithCode.find((branchVal) => {
        return branchVal.label === branch;
      });
      const GlDetails = gllList[selectedBranch.code];

      const GLValAndDesArray = GlDetails.ledger_details.map((data) => data);
      setGlAccountWithDesc(GLValAndDesArray);

      const GlAccount = GlDetails.ledger_details.map((data) => {
        return `${data["account_head"]} - ${data["account_desc"]}`;
      });
      setGLAccountArray(GlAccount);
    }
  };
  const onChangeForBranchEvent = (newValue) => {
    setBranchName(newValue);
    if (newValue?.label) {
      dispatch(BranchAction.updateInitialLoad(false));
      dispatch(BranchAction.updateHeaderBranchDetails(newValue.label));
      loadVoucherNumber(newValue);
    }
    if (newValue === null || newValue === "") {
      return;
    } else {
      setBranchNameNotValid(false);
    }
  };

  const handleCellChangedEvent = async (event) => {
    let data = datarows[event.id] ? event.id : datarows.length - 1;
    historyData[event.id] = data;
    setHistoryData(historyData);
    if (event.field === "fileBranch") {
      let data = datarows[event.id] ? event.id : datarows.length - 1;
      if (event.value) {
        datarows[data]["glAccount"] = "";
        datarows[data]["description"] = "";
        datarows[data]["appNum"] = "";
        datarows[data]["fileBranch"] = event.value;
        const selectedBranchCode = branchWithCode.find((branchVal) => {
          return branchVal.label === event.value;
        });
        datarows[data]["fileBranchCode"] = selectedBranchCode.code;
        setDatarows([...datarows]);
      } else {
        datarows[data] = {};
        setDatarows([...datarows]);
      }
    } else if (event.field === "appNum") {
      let data = datarows[event.id] ? event.id : datarows.length - 1;
      datarows[data]["appNum"] = event.value;
      datarows[data]["glAccount"] = "";
      datarows[data]["description"] = "";
      datarows[data]["debit"] = "";
      datarows[data]["credit"] = "";
      setDatarows([...datarows]);
    } else if (event.field === "glAccount") {
      glAccountOnChangeHandler(event);
    } else if (
      (event.field === "debit" || event.field === "credit") &&
      Number(event.value) > 0 &&
      Number(event.value) <= 99999999
    ) {
      let data = datarows[event.id] ? event.id : datarows.length - 1;
      if (event.field === "debit") {
        const { fileBranch, appNum, glAccount } = datarows[data];
        if (
          fileBranch !== null &&
          fileBranch !== "" &&
          fileBranch !== undefined &&
          appNum !== null &&
          appNum !== "" &&
          appNum !== undefined &&
          glAccount !== null &&
          glAccount !== "" &&
          glAccount !== undefined
        ) {
          const response = await getDebitAmountForGlAccount(
            fileBranch,
            appNum,
            glAccount
          );
          if (response.data.receiptFlag) {
            if (event.value <= response.data.amount) {
              datarows[data][event.field] = event.value;
              setDatarows([...datarows]);
            } else {
              datarows[data][event.field] = 0;
              setDatarows([...datarows]);
              setValidationSnackBarMessage(
                "Enter Debit Amount is greater that Receipt Amount"
              );
              setValidationSnackBar(true);
            }
          } else {
            setValidationSnackBarMessage(
              `Receipt is Not Created for this GL ${datarows[data]["glAccount"]} Account.`
            );
            setValidationSnackBar(true);
            datarows[data]["glAccount"] = "";
            datarows[data]["description"] = "";
            datarows[data]["debit"] = 0;
            setDatarows([...datarows]);
          }
        } else {
          setValidationSnackBarMessage(`Please Select Required Fields.`);
          setValidationSnackBar(true);
          datarows[data]["debit"] = 0;
          setDatarows([...datarows]);
        }
      } else {
        datarows[data][event.field] = event.value;
        setDatarows([...datarows]);
      }
    } else {
      let data = datarows[event.id] ? event.id : datarows.length - 1;
      datarows[data][event.field] = 0;
      setDatarows([...datarows]);
      setShowSnackBar(true);
    }

    setUpdateDisable(
      JSON.stringify(modifiedMap) === JSON.stringify(getModifiedData(datarows))
    );
    setSaveButtonDisabled(
      JSON.stringify(modifiedMap) === JSON.stringify(getModifiedData(datarows))
    );
  };

  const checkUpdatedValueWithModifiedData = (key, value) => {
    if (datarows[key["id"]][key["field"]] !== value) {
      setUpdateDisable(false);
      setSaveButtonDisabled(false);
    }
  };
  const handleCellClick = (param, event) => {
    event.defaultMuiPrevented = param.field === "Total";
  };

  const valiateTosave = () => {
    modeValue === "modify" && ceckModifyValidation();
    modeValue === "delete" && checkDeleteValidation();
    modeValue === "approve" && checkApproveValidation();
  };

  const ceckModifyValidation = async() => {
    if (!checkGridDataVaidation()) {
      setErrorDialogOpen(true);
    } else if(naration===null || naration===""){
      setNarationError(true)
    } else if (naration.length > 2000) {
      setNarationLengthError(true);
    } else if(!await validateDisbursementStatus()){
      setValidationSnackBarMessage("Unable to proceed due to disbursement is in Requested/Partial Approval State");
      setValidationSnackBar(true);
      setSaveDialogOpen(false);
    } else {
      setNarationError(false);
      setNarationLengthError(false);
      setSaveDialogOpen(true);
      setConfirmationDialogContent("Save Journal Voucher Details ?");
    }
  };
  const checkDeleteValidation = () => {
    if (!branchName || !voucherDate) {
      if (!branchName) {
        branchName ? setBranchNameNotValid(false) : setBranchNameNotValid(true);
      }
      if (!voucherDate) {
        voucherDate ? setVoucherDateError(false) : setVoucherDateError(true);
      }
    } else {
      if (datarows.length < 2) {
        setErrorDialogOpen(true);
      } else {
        setSaveDialogOpen(true);
        setConfirmationDialogContent("Delete Journal Voucher Details ?");
      }
    }
  };
  const onDeleteButtonClickHandler = async () => {
    const dataMap = {};
    dataMap["voucherId"] = voucherNumber;
    dataMap["branch"] = branchName.code;
    try {
      setLoading(true)
      setLoadingMsg("Deleting Journal Voucher Data Please wait...")
      const response = await axios.post("/jv/deleteJv", dataMap);
      if (response.data === "deleted") {
        setLoading(false)
        setJounalNumberDialogOpen(true);
        setInformationDialogContent(
          "Journal Voucher Data Deleted Successfully"
        );
        setDatarows([]);
      }
    } catch {
      setLoading(false)
      console.log("Network Error");
    }
  };
  const checkApproveValidation = async() => {
    if (!checkApproveGridDataVaidation()) {
      setErrorDialogOpen(true);
    } else if(naration===null || naration===""){
      setNarationError(true)
    } else if (naration.length > 2000) {
      setNarationLengthError(true);
    } else if(!await validateDisbursementStatus()){
      setValidationSnackBarMessage("Unable to proceed due to disbursement is in Requested/Partial Approval State");
      setValidationSnackBar(true);
      setSaveDialogOpen(false);
    } else {
      setNarationError(false);
      setNarationLengthError(false);
      setSaveDialogOpen(true);
      setConfirmationDialogContent("Approve Journal Voucher Details ?");
    }
  };
  const checkApproveGridDataVaidation = () => {
    return datarows.length >= 2;
  };
  const onApproveClickHandler = async () => {
    const dataMap = {};
    dataMap["mode"] = "approve";
    dataMap["user"] = userName;
    dataMap["branchName"] = branchName.code;
    dataMap["voucherId"] = voucherNumber;
    dataMap["voucherDate"] = new Date(voucherDate).toLocaleDateString("fr-FR");
    try {
      setLoading(true)
      setLoadingMsg("Approving Journal Voucher Details Please wait...")
      const response = await axios.post("/jv/approveJv", dataMap);
      if (response.data === "approved") {
        setLoading(false)
        setErrorDialogOpen(false);
        setJounalNumberDialogOpen(true);
        setInformationDialogContent("Journal Voucher Approved Successfully");
      } else {
        setLoading(false)
        setGlAccountDuplicateList(response.data.notAvailGl);
        setErrorApplicationList(response.data.notTallyList);
        setSaveDialogOpen(false);
        setErrorDialogOpen(true);
      }
    } catch {
      setLoading(false)
      console.log("Network Error");
    }
  };
  const setValueToNarration = (event) => {
    setNarationFlag(initialNarationValue === event.target.value);
    modeValue === "view" &&
      dispatch(JournalVoucherReducerAction.updateNaration(event.target.value));
    modeValue === "delete" && setNartation(event.target.value);
    modeValue === "approve" && setNartation(event.target.value);
    modeValue === "modify" && setNartation(event.target.value);
  };
  const validateNaration = (value) => {
    if(value){
      setNarationError(false)
      if (value.length > 2000) {
        setNarationLengthError(true);
      } else {
        setNarationLengthError(false);
      }
    }else{
      setNarationError(true)
    }
  };

  const deleteSelectedRow = (param) => {
    let newRows = datarows.filter((row) => row.id !== param.id);
    const updateRecord = newRows.map((record) => {
      if (record.id > param.id) {
        return {
          ...record,
          id: record.id - 1,
        };
      } else {
        return {
          ...record,
        };
      }
    });
    setDatarows(updateRecord);
    setSaveButtonDisabled(
      JSON.stringify(modifiedMap) ===
        JSON.stringify(getModifiedData(updateRecord))
    );
    if (updateRecord.length === 0) setSaveButtonDisabled(true);
  };
  const checkGridDataVaidation = () => {
    let allowSave = true;
    let errorList = [];
    let glAccountErrorList = [];
    let glMap = [];
    let debitCount = 0;
    let creditCount = 0;
    let creditEmptyErrorList = [];
    datarows.forEach(function (map, index) {
      creditCount = Number(map["credit"]) + creditCount;
      debitCount = Number(map["debit"]) + debitCount;

      if (
        !map["appNum"] ||
        !map["glAccount"] ||
        !map["fileBranch"] ||
        (!map["credit"] &&
          !map["debit"] &&
          (map["credit"] === 0 ||
            map["credit"] === "" ||
            map["credit"] === undefined) &&
          (map["debit"] === 0 ||
            map["debit"] === "" ||
            map["debit"] === undefined))
      ) {
        allowSave = false;
        creditEmptyErrorList.push(map["id"]);
      }

      if (glMap?.includes(map["appNum"] + map["glAccount"])) {
        if (!glAccountErrorList.includes(map["appNum"])) {
          glAccountErrorList.push(map["appNum"]);
        }
        allowSave = false;
      } else {
        glMap.push(map["appNum"] + map["glAccount"]);
      }
      if (
        !map["debit"] &&
        !map["credit"] &&
        !map["fileBranch"] &&
        !map["glAccount"] &&
        !map["appNum"]
      ) {
        emptyRowList.push(map["id"]);
        allowSave = false;
      }
    });
    if (debitCount !== creditCount) {
      allowSave = false;
      errorList.push("");
    }
    if (validationList.size !== 0 && datarows.length !== validationList.size) {
      setGlAccountNotPresent(true);
      allowSave = false;
    }
    setErrorApplicationList(errorList);
    setGlAccountErrorList(glAccountErrorList);
    setCreditEmptyErrorList(creditEmptyErrorList);
    setEmptyRowList(emptyRowList);
    return allowSave;
  };
  const getGlAccountBasedOnBranchCode = async (branchWithCode) => {
    const codes = branchWithCode.map((branches) => branches.code);
    const response = await axios.post("/filereceipt/getGLAccountDataByBranch", {
      shflApisModel: {
        apiCode: "FILE_GL_ACC_LOV_API",
        createdBy: userNames,
        lastModifiedBy: userNames,
      },
      branchCodes: codes,
    });
    if (response.status === 200) {
      setGllList(response.data);
      setJVApiDataLoading(false);
    }
  };
  const addNewRow = () => {
    let newRow = {
      id: datarows.length,
      fileBranch: branchNames.label,
      appNum: "",
      glAccount: "",
      description: "",
      debit: 0,
      credit: 0,
      fileBranchCode: "",
    };
    if (datarows.length > 0) {
      let rowMap = datarows[datarows.length - 1];
      if (
        (rowMap["credit"] || rowMap["debit"]) &&
        rowMap["fileBranch"] &&
        rowMap["glAccount"] &&
        rowMap["appNum"]
      ) {
        let newList = [];
        datarows.forEach((map) => {
          newList.push(map);
        });
        newList.push(newRow);
        setDatarows(newList);
      } else {
        setAddRowSnackBarShow(true);
      }
    } else {
      let newList = [];
      newList.push(newRow);
      setDatarows([newRow]);
    }
  };

  const isCellEditable = (params) => {
    const columnsData = [...columns];
    const currentColumn = columnsData.find((col) => {
      return params.field === col.field;
    });
    return currentColumn.editable;
  };

  return (
    <div>
      <div style={{ minHeight: "calc(100vh - 108px)" }}>
        <Box
          sx={{
            marginBottom: "8px",
            marginTop: "-1%",
            gap: "8px",
          }}
        >
          <AccordianContainer
            id="accord-jv"
            title="Journal Voucher"
            initialOpen={true}
          >
            <Box id="accord-box-jv" component="form" validate="true">
              <Box
                sx={{
                  marginBottom: "8px",
                  marginTop: "-1%",
                  direction: "rtl",
                  gap: "8px",
                  justifyContent: "flex-end",
                  marginRight: "20px",
                }}
              >
                <Tooltip title="Ctrl+D">
                  <IconButton
                    aria-label="Clear"
                    color="primary"
                    onClick={clearButtonClickHandler}
                    ref={clearRef}
                  >
                    <HighlightOffIcon />
                  </IconButton>
                </Tooltip>

                {specialAccessHeaderMap.journalVoucherApprove && (
                  <Tooltip title="Ctrl+U">
                    <IconButton
                      aria-label="Approve"
                      color="primary"
                      disabled={jvApiDataLoading}
                      onClick={approveOperation}
                      ref={approveRef}
                    >
                      <CheckCircleIcon />
                    </IconButton>
                  </Tooltip>
                )}

                {specialAccessHeaderMap.journalVoucherDelete && (
                  <Tooltip title="Ctrl+B">
                    <IconButton
                      aria-label="Delete"
                      color="primary"
                      disabled={jvApiDataLoading}
                      onClick={deleteOperation}
                      ref={deleteRef}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                )}

                {specialAccessHeaderMap.journalVoucherModify && (
                  <Tooltip title="Ctrl+M">
                    <IconButton
                      aria-label="Modify"
                      color="primary"
                      disabled={jvApiDataLoading}
                      onClick={modifyOperation}
                      ref={modifyRef}
                    >
                      <ModeEditIcon />
                    </IconButton>
                  </Tooltip>
                )}

                {specialAccessHeaderMap.journalVoucherView && (
                  <Tooltip title="Ctrl+E">
                    <IconButton
                      aria-label="View"
                      color="primary"
                      disabled={jvApiDataLoading}
                      onClick={viewOperation}
                      ref={viewRef}
                    >
                      <RemoveRedEyeIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
              <Grid item container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                  <CustomAutoComplete
                    required={true}
                    label="Branch"
                    id="branch"
                    variant="standard"
                    value={branchName}
                    onChange={(event, newValue) => {
                      setActiveField("branch");
                      setActiveFieldValue(newValue);
                      if (saveButtonDisabled && narationFlag) {
                        onChangeForBranchEvent(newValue);
                        setVoucherNumber("");
                        setVoucherDate(null);
                        setGridVisible(false);
                        setSaveButtonDisabled(true);
                      } else {
                        setDiscardDialogFlag(true);
                      }
                    }}
                    type="text"
                    placeholder="Branch"
                    autoCompleteValues={branchNames}
                  />
                  {branchNameNotValid && (
                    <p className="error">Please Select Branch</p>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                  <CustomAutoComplete
                    required={true}
                    label="Voucher Number"
                    id="refdate"
                    value={voucherNumber}
                    type="text"
                    placeholder=""
                    variant="standard"
                    autoCompleteValues={voucherNumberList}
                    onChange={(event, newValue) => {
                      setActiveField("voucherNumber");
                      setActiveFieldValue(newValue);
                      if (saveButtonDisabled && narationFlag) {
                        setVoucherNumber(newValue);
                        loadVoucherNumberStatus(newValue);
                        let date = voucherDateList[newValue].split("/");
                        setVoucherDate(
                          dayjs(date[2] + "/" + date[1] + "/" + date[0])
                        );
                        newValue
                          ? setVoucherNumberError(false)
                          : setVoucherNumberError(true);
                        setSaveButtonDisabled(true);
                        setGridVisible(false);
                      } else {
                        setDiscardDialogFlag(true);
                      }
                    }}
                  />
                  {voucherNumberError && (
                    <p className="error">Please Enter Voucher Number</p>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                  <CustomDateField
                    disabled={true}
                    label="Voucher Date"
                    id="dueDate"
                    disablePast={false}
                    variant="standard"
                    value={voucherDate}
                    minDate={"1970/01/01"}
                    maxDate={"2055/12/31"}
                    type="text"
                    placeholder="Voucher Date"
                    onChange={(event) => {
                      if (updateDisable) {
                        if (!event) {
                          setVoucherDate(null);
                          setGridVisible(false);
                        } else {
                          setVoucherDate(new Date(event));
                          setGridVisible(false);
                        }
                        setVoucherDateError(false);
                        setVoucherNumber("");
                        new Date(event).toDateString() !== "Invalid Date" &&
                        event !== null &&
                        new Date(event).toLocaleDateString().slice(-4) >=
                          "1970" &&
                        new Date(event).toLocaleDateString().slice(-4) <= "2055"
                          ? setVoucherValidDateError(false)
                          : setVoucherValidDateError(true);
                      }
                    }}
                  />
                  {voucherDateError && (
                    <p className="error">Please Enter Voucher Date</p>
                  )}
                  {voucherValidDateError && (
                    <p className="error">Please Enter Valid Date</p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                  <CustomTextField
                    required={false}
                    disabled={true}
                    label="Voucher Status"
                    id="refdate"
                    value={voucherStatus}
                    type="text"
                    placeholder=""
                    variant="standard"
                  />
                </Grid>
              </Grid>
            </Box>
          </AccordianContainer>
          {gridVisible && (
            <AccordianContainer
              id="accord-jv"
              title="Journal Voucher Information"
              initialOpen={true}
              sx={{ margin: "8px !important" }}
            >
              <>
                {addButtonVisible && (
                  <div
                    style={{
                      direction: "rtl",
                      marginBottom: "4px",
                    }}
                  >
                    <Tooltip title="Ctrl+A">
                      <CustomButton
                        variant="contained"
                        onClick={addNewRow}
                        ref={addRowRef}
                      >
                        +
                      </CustomButton>
                    </Tooltip>
                  </div>
                )}

                <CustomDataGrid
                  noDataMessage="No Data."
                  noDataOnFilterMessage="No Data on Applied Filter."
                  rows={datarows}
                  gridLazyLoad={() => {}}
                  onSortModelChange={() => {}}
                  rowHeight={40}
                  gridHeight={
                    datarows.length < 5 && datarows.length !== 0
                      ? datarows.length * 40 + 130
                      : 305
                  }
                  columns={columns}
                  pageSize={10}
                  pageSizeOptions={[10]}
                  onCellEditCommit={(event) => handleCellChangedEvent(event)}
                  onCellDoubleClick={(event) => {
                    if (event.field === "appNum") {
                      if (
                        event.row.fileBranch !== "" &&
                        event.row.fileBranch !== null
                      ) {
                        loadApplicationNumBasedOnBranchName(event);
                      } else {
                        setApplicationList([]);
                      }
                    }
                  }}
                  onCellKeyDown={(event, param) => {
                    (param.key === "e" ||
                      param.key === "E" ||
                      param.key === ".") &&
                      param.preventDefault();
                    checkUpdatedValueWithModifiedData(
                      event,
                      param.target.value
                    );
                  }}
                  onCellClick={handleCellClick}
                  isCellEditable={isCellEditable}
                  onRowClick={(params) => {
                    setLoanClosed(params.row.losStatus);
                    onRowClickHandler(params.row);
                    if (
                      (params.row.debit === "" ||
                        params.row.debit === null ||
                        params.row.debit === 0 ||
                        params.row.debit === "0") &&
                      (params.row.credit === "" ||
                        params.row.credit === null ||
                        params.row.credit === 0 ||
                        params.row.credit === "0")
                    ) {
                      setDebitColumnEnable(true);
                      setCreditColumnEnable(true);
                    } else if (
                      (params.row.debit === "" ||
                        params.row.debit === null ||
                        params.row.debit === 0 ||
                        params.row.debit === "0") &&
                      (params.row.credit !== "" ||
                        params.row.credit !== null ||
                        params.row.credit !== 0 ||
                        params.row.credit !== "0")
                    ) {
                      setDebitColumnEnable(false);
                      setCreditColumnEnable(true);
                    } else if (
                      (params.row.debit !== "" ||
                        params.row.debit !== null ||
                        params.row.debit !== 0 ||
                        params.row.debit !== "0") &&
                      (params.row.credit === "" ||
                        params.row.credit === null ||
                        params.row.credit === 0 ||
                        params.row.credit === "0")
                    ) {
                      setDebitColumnEnable(true);
                      setCreditColumnEnable(false);
                    }
                  }}
                />

                <Grid container rowSpacing={0} columnSpacing={1}>
                  <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                    <CustomTextField
                      type="naration"
                      label="Narration"
                      variant="standard"
                      required={modeValue !== "view"}
                      disabled={narrationDisable}
                      value={naration}
                      onChange={setValueToNarration}
                      onBlur={(event) => validateNaration(event.target.value)}
                    ></CustomTextField>
                    {narationError && (
                      <p className="error">Please Enter Narration</p>
                    )}
                    {narationLengthError && (
                      <p className="error">
                        Value is too long. Input less than 2000 characters.
                      </p>
                    )}
                  </Grid>
                </Grid>
              </>

              {saveButton && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Ctrl+S" placement="top">
                    <Button
                      variant="contained"
                      onClick={valiateTosave}
                      disabled={
                        datarows.length === 0 ||
                        (!naration &&
                          modeValue === "modify" &&
                          saveButtonDisabled &&
                          narationFlag)
                      }
                      ref={saveRef}
                    >
                      {saveButtonName}
                    </Button>
                  </Tooltip>
                </Box>
              )}
            </AccordianContainer>
          )}
        </Box>

        <CustomConfirmationDialog
          dialogOpen={savedDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Confirmation</Typography>
          }
          dialogContent={confirmationDialogContent}
          hideCancelButton={false}
          okButtonName={"OK"}
          cancelButtonName={"Cancel"}
          onOkClick={onSaveButtonClickHandler}
          onDialogClose={() => {
            setSaveDialogOpen(false);
          }}
        />
        <CustomConfirmationDialog
          dialogOpen={jounalNumberDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Information</Typography>
          }
          dialogContent={informationDialogContent}
          hideCancelButton={true}
          okButtonName={"OK"}
          cancelButtonName={""}
          onOkClick={onInformationOkHandler}
        />
        <CustomConfirmationDialog
          dialogOpen={errorDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Error</Typography>
          }
          dialogContent={
            <>
              {modeValue === "delete" && (
                <Typography sx={{ fontSize: "1rem" }}>
                  Load the journal data before delete
                </Typography>
              )}
              {modeValue === "approve" && (
                <>
                  {errorApplicationList.length > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      The Following Application Numbers are not Tally, Kindly
                      Check Once Again
                    </Typography>
                  )}
                  {errorApplicationList.length > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      {errorApplicationList.join(", ")}
                    </Typography>
                  )}
                  {glAccountErrorList.length > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      The Following Application Numbers Gl Account Numbers are
                      duplicate, Kindly Check Once Again
                    </Typography>
                  )}
                  {glAccountErrorList.length > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      {glAccountErrorList.join(", ")}
                    </Typography>
                  )}

                  {emptyRowList.length > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      There are some Empty row in the table
                    </Typography>
                  )}
                  {glAccountNotPresent > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      Gl Account is not present in File Receipt.
                    </Typography>
                  )}
                  {debitAmountNotValid > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      Debit amount is greater than file Receipt Gl Amount
                    </Typography>
                  )}
                  {glAccountDuplicateList.length > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      The Following Application Numbers Gl Account is not
                      present in File Receipt
                    </Typography>
                  )}
                  {glAccountDuplicateList.length > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      {glAccountDuplicateList.join(", ")}
                    </Typography>
                  )}
                </>
              )}
              {modeValue === "modify" && (
                <>
                  {errorApplicationList.length > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      Entered Application Numbers Credit/Debit Value is
                      mismatched
                    </Typography>
                  )}
                  {glAccountErrorList.length > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      Multiple records are present in the table
                    </Typography>
                  )}
                  {glAccountErrorList.length > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      {glAccountErrorList.join(", ")}
                    </Typography>
                  )}
                  {creditEmptyErrorList.length > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      Please Fill all the values.
                    </Typography>
                  )}

                  {emptyRowList.length > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      There are some Empty row in the table
                    </Typography>
                  )}
                  {glAccountNotPresent && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      Gl Account is not present in File Receipt.
                    </Typography>
                  )}
                  {accountNoIsnotReceipted && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      Application Number is not present in File Receipt.
                    </Typography>
                  )}
                  {debitAmountNotValid > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      Debit amount is greater than file Receipt Gl Amount
                    </Typography>
                  )}
                  {glAccountDuplicateList.length > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      The Following Application Number's Gl Account is not
                      present in File Receipt
                    </Typography>
                  )}
                  {glAccountDuplicateList.length > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      {glAccountDuplicateList.join(", ")}
                    </Typography>
                  )}
                  {accountNoIsnotReceiptedList.length > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      The Following Application Number is not present in File
                      Receipt
                    </Typography>
                  )}
                  {accountNoIsnotReceiptedList.length > 0 && (
                    <Typography sx={{ fontSize: "1rem" }}>
                      {accountNoIsnotReceiptedList.join(", ")}
                    </Typography>
                  )}
                </>
              )}
            </>
          }
          hideCancelButton={true}
          okButtonName={"OK"}
          cancelButtonName={""}
          onOkClick={() => setErrorDialogOpen(false)}
        />
        <Snackbar
          open={validationSnackBar}
          autoHideDuration={3000}
          // anchorOrigin={{ vertical, horizontal }}
          onClose={() => {
            setValidationSnackBar(false);
          }}
        >
          <Alert
            onClose={() => {
              setValidationSnackBar(false);
            }}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {validationSnackBarMessage}
          </Alert>
        </Snackbar>
        <Dialog
          open={informationDialog}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>Information</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {informationDialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Ctrl+K" placement="top">
              <Button
                onClick={() => {
                  setInformationDialog(false);
                }}
              >
                Ok
              </Button>
            </Tooltip>
          </DialogActions>
        </Dialog>
        <CustomSnackBar
          showSnackbar={addRowSnackBarShow}
          autoHideDuration={5000}
          onClose={() => {
            setAddRowSnackBarShow(false);
          }}
          message={"Please Enter all fileld value"}
          severity="warning"
          color={"red"}
        />
        <Dialog open={discardDialogFlag}>
          <DialogTitle>
            <h4>Confirmation</h4>
          </DialogTitle>
          <DialogContent>
            JV process not completed. Do you want to change and continue?
          </DialogContent>
          <DialogActions>
            <Tooltip title="Ctrl+Q" placement="top">
              <Button
                onClick={() => {
                  setDiscardDialogFlag(false);
                }}
              >
                Cancel
              </Button>
            </Tooltip>
            <Tooltip title="Ctrl+Y" placement="top">
              <Button onClick={discardDialogOnOkClickHandler}>YES</Button>
            </Tooltip>
          </DialogActions>
        </Dialog>
        <CustomSnackBar
          showSnackbar={showSnackBar}
          autoHideDuration={5000}
          onClose={() => {
            setShowSnackBar(false);
          }}
          message={"Amount should be greater than 0."}
          severity="warning"
          color={"red"}
        />
        {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
              <p>{loadingMsg}</p>
            </Box>
          </Backdrop>
        </>
      )}
      </div>
      <StlapFooter />
    </div>
  );
};
export default JournalVoucherDetail;
